import { mergeStyleSets } from '@fluentui/react';

export const getVpnLockOverlayStyles = () => {
    return mergeStyleSets({
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: '#f3f2f1', // Light gray background like Microsoft apps
            zIndex: 10000000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        content: {
            backgroundColor: '#eeacb2', // Light pink/red background
            border: '2px solid #a80000', // Dark red border
            borderRadius: '10px',
            maxWidth: '600px',
            width: '90%',
            overflow: 'hidden',
        },
        header: {
            backgroundColor: '#a80000', // Dark red header
            padding: '12px 20px',
            textAlign: 'center',
        },
        headerTitle: {
            color: '#ffffff',
            fontWeight: 700,
            fontSize: '24px',
            margin: 0,
            textTransform: 'uppercase',
            letterSpacing: '1px',
        },
        body: {
            padding: '20px 24px',
        },
        paragraph: {
            color: '#1F2937',
            fontSize: '18px',
            lineHeight: '1.6',
            margin: '0 0 16px 0',
        },
        lastParagraph: {
            color: '#1F2937',
            fontSize: '18px',
            lineHeight: '1.6',
            margin: 0,
        },
        link: {
            color: '#0066cc',
            textDecoration: 'underline',
        },
        // Keep old styles for backward compatibility but they won't be used
        iconContainer: {
            display: 'none',
        },
        warningIcon: {
            display: 'none',
        },
        title: {
            display: 'none',
        },
        description: {
            display: 'none',
        },
        errorMessage: {
            display: 'none',
        },
        instructionsContainer: {
            display: 'none',
        },
        instructionsTitle: {
            display: 'none',
        },
        instructionsList: {
            display: 'none',
        },
        retryButton: {
            display: 'none',
        },
        footer: {
            display: 'none',
        },
    });
};
